import { NEW_STRATEGY_SUCCESS } from "fleet/redux-store/strategies";
import reduceReducers from "reduce-reducers";
import { swapElem } from "util/array";

import {
  STRATEGY_ADD_SPOTS,
  STRATEGY_DELETE_SPOT,
  STRATEGY_PRIORITY_ORDER,
  STRATEGY_RESET_REDIRECT,
  UPDATE_STRATEGY,
} from "./actions";

const initialStrategy = {
  name: "",
  main: [],
  fallback: [],
};

const initialState = {
  strategy: initialStrategy,
  redirectTo: null,
};

function reindex(spot, index) {
  return {
    ...spot,
    _rowNum: index,
  };
}

function priorityOrderReducer(strategy, action) {
  const { dir, index, priority } = action.payload;
  const oldSpots = strategy[priority];
  const spots = swapElem(index + dir, index, oldSpots);

  return {
    ...strategy,
    [priority]: spots.map(reindex),
  };
}

function deleteSpotReducer(strategy, action) {
  const { index, priority } = action.payload;
  const spots = strategy[priority];

  spots.splice(index, 1);

  return {
    ...strategy,
    [priority]: spots.map(reindex),
  };
}

function addSpotsReducer(strategy, action) {
  const { spots: newSpots, priority } = action.payload;
  const curSpots = strategy[priority];

  const spots = [...curSpots, ...newSpots];

  return {
    ...strategy,
    [priority]: spots.map(reindex),
  };
}

function strategyUpdateReducer(state = initialState, action) {
  switch (action.type) {
    case STRATEGY_ADD_SPOTS:
      return {
        ...state,
        strategy: addSpotsReducer(state.strategy, action),
      };
    case STRATEGY_DELETE_SPOT:
      return {
        ...state,
        strategy: deleteSpotReducer(state.strategy, action),
      };
    case STRATEGY_PRIORITY_ORDER:
      return {
        ...state,
        strategy: priorityOrderReducer(state.strategy, action),
      };
    case UPDATE_STRATEGY:
      return {
        ...state,
        strategy: { ...action.payload },
      };
    default:
      return state;
  }
}

function strategyRedirectReducer(state = initialState, action) {
  switch (action.type) {
    case NEW_STRATEGY_SUCCESS:
      return {
        ...state,
        redirectTo: action.payload.data.id,
      };
    case STRATEGY_RESET_REDIRECT:
      return {
        ...state,
        redirectTo: null,
      };
    default:
      return state;
  }
}

const strategyDetailReducer = reduceReducers(
  strategyUpdateReducer,
  strategyRedirectReducer,
);

export {
  deleteSpotReducer,
  initialState,
  initialStrategy,
  priorityOrderReducer,
  strategyDetailReducer,
  addSpotsReducer,
  reindex,
};
